// Delivery Carrier Controller (Greek checkout)
// Shows the "which locker?" field only while Box Now is the chosen courier.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["choice", "locker"]

  connect() { this.toggle() }

  toggle() {
    if (!this.hasLockerTarget) return
    const picked = this.choiceTargets.find((radio) => radio.checked)
    this.lockerTarget.classList.toggle("hidden", !(picked && picked.value === "box_now"))
  }
}
